<script>
// import Layout from "../../layouts/main.vue";
// import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import { usePermissions } from '@/composables/usePermissions';

export default {
    page: {
        title: "Active Customers",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Active Customers",
            items: [
                {
                text: "Active Customers",
                href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
        
            customerList:[],
            channelpartnerlist:[],
            fincoList:[],
            countryList:[],
            loadingDetail:false,
            loadingRoles:true,
            isButtonDisabled:false,
            date: '',
            key_search:'',
            program_id:null,
            dtKey:0,
            branchList:null,
            branch_id:null,
            programList:null,
        };
    },
    setup() {
        const permissions = usePermissions();
        
        return {
            permissions,
        };
    },
    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
            }
        },

        currentDate() {
            const current = new Date();
            const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
            return date;
        },

        lastthirtyday(){
            return moment().subtract(30, 'days').format('DD/MM/YYYY')
        },

        downloadExcel: function () {
            //this.export_params = 'date='+this.date+'&key_search='+this.key_search+'&branch_id='+this.branch_id+'&program_id='+this.program_id;
            //location.href= process.env.VUE_APP_API_BASEURL+'customer/export/'+this.export_params;
            if(this.branch_id != null){
                if(this.branch_id.length == 0){
                    this.branch_id = '';
                }
            }
            if(this.program_id != null){
                if(this.program_id.length == 0){
                    this.program_id = '';
                }
            }
            const posting_ = {                
                date: this.date,
                key_search: this.key_search,
                branch_id: this.branch_id,
                program_id: this.program_id,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'customer/export', posting_, {responseType: 'blob'})
            .then(response => {
                if (response) {
                    
                    console.log(response);
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
   
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'Customers List.xlsx');
                    document.body.appendChild(fileLink);
   
                    fileLink.click();
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        getCustomerList(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'program/get_customerlist')
            .then(response => {
                console.log("cust-list", response);
                if (response) {
                    this.loadingRoles=false;
                    this.customerList = response.data;
                    console.log(this.customerList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        submitForm(e)
        {
            this.isButtonDisabled=true;
            e.preventDefault()
            if(this.branch_id != null){
                if(this.branch_id.length == 0){
                    this.branch_id = '';
                }
            }
            if(this.program_id != null){
                if(this.program_id.length == 0){
                    this.program_id = '';
                }
            }
            
            const posting_ = {                
                date: this.date,
                key_search: this.key_search,
                branch_id: this.branch_id,
                program_id: this.program_id,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'customer/search', posting_)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.customerList = response.data;
                    this.dtKey +=1;
                    console.log(this.customerList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            })
            .finally(() => {
                this.isButtonDisabled = false;
            });
        },

        resetForm: function () { 
            this.date = ''; 
            this.key_search = null; 
            this.program_id = null; 
            this.branch_id = null; 
            // this.getCustomerList();
        },


        //raw data----------------------------------------------------------

        get_channel_partner(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'channelpartner/raw_data')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.channelpartnerlist = response.data;
                    console.log(this.channelpartnerlist);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        get_finco(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'finco/raw_data')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.fincoList = response.data;
                    console.log(this.fincoList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        get_country(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'finco/raw_data_country')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.countryList = response.data;
                    console.log(this.countryList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        get_program(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'program/raw_data')
            .then(response => {
                if (response) {
                    this.programList = response.data;
                    console.log(this.programList);
                    const programListmap = this.programList.map((programList) => {
                        return {
                            value: programList.id,
                            label: programList.program_name,
                        }
                        })
                    this.programList = programListmap;
                    
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        get_branch(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'branch/list')
            .then(response => {
                if (response) {
                    this.branchList = response.data;
                    const branchlistmap = this.branchList.map((branchList) => {
                        return {
                            value: branchList.id,
                            label: branchList.name,
                        }
                        })
                    this.branchList = branchlistmap;
                    console.log(this.branchList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        //raw data----------------------------------------------------------

    },

    components: {
        DataTable,
        flatPickr,
        Multiselect,
    },

    mounted() {
        this.getCustomerList();
        this.get_program();
        this.get_branch();
    },
    
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <!-- <PageHeader :title="title" :items="items" /> -->
        <!--div class="d-flex justify-content-end mb-3">
            <button @click="downloadExcel()" class="btn btn-success" v-if="this.role != 3"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button><br><br>
        </div-->
    <!--button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#add_new_program_modal"  v-if="this.role = 1"><i class="ri-add-line align-middle me-1"></i> Add New Program</button> <br><br-->
        <div class="card">
            <div class="card-header border-bottom-dashed">
                <div class="row g-4 align-items-center">
                    <div class="col-sm">
                        <div>
                            <h5 class="card-title mb-0">Customer List</h5>
                        </div>
                    </div>
                    <div class="col-sm-auto">
                        <div>
                            <button v-if="permissions.canExport?.value" @click="downloadExcel()" class="btn btn-success"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body border-bottom-dashed border-bottom">
                <form @submit.prevent="submitForm" ref="searchCustomer">
                <div class="row g-3">
                    <div class="col-xl-6">
                        <div class="search-box">
                            <input type="text" class="form-control search"
                            placeholder="Search for Customer Name, NRIC, Email Address" v-model="key_search"/>
                            <i class="ri-search-line search-icon"></i>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-xl-6 pb-3">
                        <div class="row g-3">
                            <div class="col-sm-12">
                                <div class="">
                                    <flat-pickr v-model="date" placeholder="Select Date" :config="rangeDateconfig"
                                    class="form-control"></flat-pickr>
                                </div>
                            </div>
        
                            <!--end col-->

               
                            <!--end col-->
                        </div>
                    </div>
                </div>

                <div class="row g-3">
             
                    <!--end col-->
                    <div class="col-xl-12 pb-3">
                        <div class="row g-3">
 
                            <!--end col-->
                            <div class="col-sm-6">
                                <!-- <div>
                                    <select v-model="branch_id" class="form-select mb-4">
                                        <option value="" disabled>Select Branch</option>
                                        <option v-for="(item, index) in branchList" :key="index" :value="item.id" >
                                            {{ item.name }}
                                        </option>
                                    </select>
                                </div> -->
                                <Multiselect placeholder="Select Branch" v-model="branch_id" mode="tags" :close-on-select="true" :searchable="true"
                                    :create-option="false" :options="branchList" />
                            </div>
                            <!--end col-->

                            <div class="col-sm-6">
                                <!-- <select v-model="program_id" class="form-select mb-4">
                                    <option value="" disabled>Select Program</option>
                                    <option v-for="(item, index) in programList" :key="index" :value="item.id" >
                                        {{ item.program_name }}
                                    </option>
                                </select> -->
                                <Multiselect placeholder="Select Program" v-model="program_id" mode="tags" :close-on-select="true" :searchable="true"
                                    :create-option="false" :options="programList" />
                            </div>
                            <!--end col-->
                        </div>
                    </div>
                </div>
                <div class="row g-3 justify-content-end">
                    <div class="col-xl-2">
                        <div>
                            <button type="submit" class="btn btn-primary w-100" :disabled="isButtonDisabled">
                                <i class="ri-equalizer-fill me-2 align-bottom"></i>Search
                            </button>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-xl-2">
                        <div>
                            <button type="button" @click='resetForm' class="btn btn-danger w-100">
                                <i class="ri-refresh-fill me-2 align-bottom"></i>Reset
                            </button>
                        </div>
                    </div>
                </div>
                <!--end row-->
                </form>
            </div>
            <div class="card-body">
                <h6>* Customers data display from {{lastthirtyday()}} to {{currentDate()}}</h6>
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                <DataTable :options="{lengthChange: false,searching: false}" :key="dtKey" class="table table-striped table-nowrap mb-0" id="example">  
                                     <thead class="table-secondary">
                                        <tr>
                                            <th>#.</th>
                                            <th scope="col">Customer Name</th>  
                                            <th scope="col">Order No.</th>
                                            <th scope="col">NRIC</th>           
                                            <th scope="col">Email Address</th>           
                                            <th scope="col">Program</th>                                                      
                                            <th scope="col">Application Branch</th>
                                            <th scope="col">Application Source</th>
                                            <!--th scope="col">Credit Status Check</th-->
                                            <th scope="col">Created On</th>
                                            <th scope="col">Payment Check</th>
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr v-for="(item, index) in customerList" :key="index" class="content">
                                            <td>{{ index+1 }}</td>                               
                                            <td><router-link :to="'/customer/customer-details/'+item.id" class="fw-medium link-secondary">{{ item.name_as_per_nric }}</router-link></td>                                            
                                            <td><router-link :to="'/orders/customer-order-details/'+item.id" class="fw-medium link-secondary">{{ item.orderId }}</router-link></td>
                                            <td>{{ item.nric }}</td>
                                            <!--td>{{ item.phone_number }}</td-->
                                            <td>{{ item.email }}</td>
                                            <td>{{ item.program_name }}</td>
                                            <td>{{ item.application_branch }}</td>    
                                            <!-- <td v-if="item.applicationsource == null">NULL</td> -->
                                            <td>{{item.program_type}}</td>  
                                                                               
                                            <!--td></td-->                                          
                                            <td>{{ format_date(item.created_at) }}</td>  
                                            <td v-if="item.payment_check == 1"><span class="badge bg-success">PASSED</span></td>
                                            <td v-else-if="item.payment_check == 2"><span class="badge bg-danger">FAILED</span></td>
                                            <td v-else>---</td>                                       
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>